import React, { useEffect, useState } from "react";
import { api } from "@/api";

export default function AdSlot({ placement, className = "" }) {
  const [ads, setAds] = useState([]);
  useEffect(() => {
    api.get("/ads", { params: { placement } }).then(r => setAds(r.data.ads)).catch(() => {});
  }, [placement]);
  if (!ads.length) return null;
  return (
    <div className={`grid ${ads.length > 1 ? "md:grid-cols-2" : ""} gap-3 ${className}`} data-testid={`ad-slot-${placement}`}>
      {ads.slice(0, 2).map(a => (
        <a key={a.id} href={a.link_url || "#"} target="_blank" rel="noreferrer"
          className="card-cartoon p-3 flex items-center gap-3 btn-pop hover:shadow-cartoon-lg overflow-hidden">
          {a.image_url && <img src={a.image_url} alt={a.title} className="w-16 h-16 rounded-2xl object-cover flex-shrink-0"/>}
          <div className="min-w-0">
            <div className="text-[10px] uppercase text-[#7649e6] font-bold">Sponsored {a.sponsor && `• ${a.sponsor}`}</div>
            <div className="font-display text-base truncate">{a.title}</div>
          </div>
        </a>
      ))}
    </div>
  );
}
